var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "d-flex w-100 py-2",
      class: ["justify-content-" + _vm.align],
    },
    [
      _vm.append.length == 0
        ? _c("div", { staticClass: "d-flex", class: _vm.contentClass }, [
            _vm.label
              ? _c(
                  "span",
                  { staticClass: "pl-1", class: { "order-2": _vm.leftOrder } },
                  [_vm._v("\n      " + _vm._s(_vm.label) + "\n    ")]
                )
              : _vm.labelHTML
              ? _c("span", {
                  staticClass: "pl-1",
                  class: { "order-2": _vm.leftOrder },
                  domProps: { innerHTML: _vm._s(_vm.labelHTML) },
                })
              : _vm._e(),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "pl-1",
                class: _vm.valueClass,
                style: !_vm.leftOrder ? { "padding-right": "1px" } : {},
              },
              [_vm._v("\n      " + _vm._s(_vm.formattedValue) + "\n    ")]
            ),
            _vm._v(" "),
            _c(
              "span",
              {
                style:
                  _vm.align === "formattedValueRight"
                    ? { "padding-left": "2px" }
                    : {},
              },
              [_vm._v(_vm._s(_vm.append))]
            ),
          ])
        : _c("div", { staticClass: "d-flex", class: _vm.contentClass }, [
            _vm.label
              ? _c(
                  "span",
                  { staticClass: "pl-1", class: { "order-2": _vm.leftOrder } },
                  [
                    _vm._v(
                      "\n      " +
                        _vm._s(
                          _vm.label +
                            " " +
                            _vm.formattedValue +
                            " " +
                            _vm.append
                        ) +
                        "\n    "
                    ),
                  ]
                )
              : _vm.labelHTML
              ? _c(
                  "span",
                  { staticClass: "pl-1", class: { "order-2": _vm.leftOrder } },
                  [
                    _c("span", {
                      domProps: { innerHTML: _vm._s(_vm.labelHTML) },
                    }),
                    _vm._v(
                      " " +
                        _vm._s(" " + _vm.formattedValue + " " + _vm.append) +
                        "\n    "
                    ),
                  ]
                )
              : _vm._e(),
          ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }